import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ThemeProvider } from "styled-components";
import merge from "ts-deepmerge";
import defaultTheme from "../_defaultTheme";
import defaultTranslations from "../translations";
import TranslationContext from "./TranslationContext";
export default function ContextProvider({ children, translations, theme, }) {
    const currentTranslations = useMemo(() => {
        return { ...defaultTranslations, ...translations };
    }, [translations]);
    const currentTheme = useMemo(() => {
        return merge(defaultTheme, theme);
    }, [theme]);
    return (_jsx(TranslationContext.Provider, { value: currentTranslations, children: _jsx(ThemeProvider, { theme: currentTheme, children: children }) }));
}
